import React, {useEffect, useState} from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {searchProducts} from "../actions/ApiCalls";
import {useNavigate} from "react-router-dom";
import {isMobile} from "react-device-detect";

function Search() {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [products, setProducts] = useState<any[]>([]);
    const customer_code = localStorage.getItem('customer_code');

    const formatPrice = (price: number | string): string => {
        const numPrice = typeof price === 'string' ? parseFloat(price) : price;
        return `R${numPrice.toFixed(2)}`;
    };


    useEffect(() => {
        searchProducts(searchTerm)
            .then(response => {
                setProducts(response.data.data);
            })
            .catch(error => {
                console.error("Failed to fetch filtered products:", error);
            });
    }, [searchTerm]);

    const wineURL = 'https://vinimark.s3.amazonaws.com/web/';
    const navigate = useNavigate();

    const handleImageClick = (product: any) => {
        const prod = products.find(p => p.search_name === product);


        if (prod.brand.search_name) {
            navigate(`/our-wines/${prod.brand.search_name}/${prod.search_name}`);
        }
    };

    const isDesktop = !isMobile;
    const [imageRatios, setImageRatios] = useState<{[key: string]: number}>({});

    function getDesktopLayout() {
        return products.map((product: any) => (
            <div
                key={product.id}
                style={{
                    flex: '1 1 calc(25% - 20px)',
                    textAlign: 'center',
                    paddingBottom: '10px',
                    maxHeight: '750px',
                    maxWidth: '400px',
                    cursor: 'pointer',
                }}
                onClick={() => handleImageClick(product.search_name)}
            >
                <div
                    style={{
                        width: '100%',
                        backgroundColor: '#f5f5f5',
                        height: '600px',
                        position: 'relative',
                        padding: '0 30px',
                        boxSizing: 'border-box',
                    }}
                >
                    <img
                        src={wineURL + product.image_path}
                        alt={product.name}
                        onLoad={(e) => {
                            const img = e.target as HTMLImageElement;
                            const ratio = img.naturalHeight / img.naturalWidth;
                            setImageRatios(prev => ({...prev, [product.id]: ratio}));
                        }}
                        style={{
                            position: 'absolute',
                            bottom: '50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            ...calculateImageDimensions(imageRatios[product.id] || 1.5, 600),
                            objectFit: 'contain'
                        }}
                    />
                </div>
                {/* ... rest of the product info ... */}
                <p style={textLight}>{product?.brand?.name}</p>
                <p style={productName}>{product.name}</p>
                <p style={productYear}>{product.year}</p>
                {customer_code && product.price_bottle && (
                    <p style={priceText}>{formatPrice(product.price_bottle)}</p>
                )}
            </div>
        ));
    }
    const textLight: React.CSSProperties = {
        fontWeight: 400,
        marginBottom: 0,
        fontSize: '13px',
        lineHeight: '16.9px',
        width: '100%'

    };

    const productName: React.CSSProperties = {
        fontWeight: 600,
        textTransform: 'uppercase',
        marginTop: 0,
        marginBottom: 0,
        fontSize: '13px',
        lineHeight: '16.9px',
    };

    const productYear: React.CSSProperties = {
        fontWeight: 600,
        textTransform: 'uppercase',
        marginTop: 0,
        marginBottom: 0,
        fontSize: '13px',
        lineHeight: '16.9px',
    };

    const priceText: React.CSSProperties = {
        fontSize: '13px',
        lineHeight: '16.9px',
        marginTop: 0,
        fontWeight: 400,
    };

    const calculateImageDimensions = (imageRatio: number, containerHeight: number) => {
        const maxHeight = containerHeight - 100; // 50px from top and bottom
        const maxWidth = '90%';

        if (imageRatio > 1.5) { // Taller image
            return {
                height: `${maxHeight}px`,
                width: 'auto',
                maxWidth
            };
        } else { // Wider image
            return {
                height: 'auto',
                width: maxWidth,
                maxHeight: `${containerHeight < 500 ? containerHeight * 0.6 : containerHeight * 0.7}px`

            };
        }
    };

    // In getMobileLayout function, update the image container and image styles
    function getMobileLayout() {
        return products.map((product: any) => (
            <div
                key={product.id}
                style={{
                    width: '100%',
                    textAlign: 'center',
                    paddingBottom: '30px',
                    maxHeight: '750px',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        backgroundColor: '#f5f5f5',
                        height: '400px',
                        position: 'relative',
                        padding: '0 30px',
                        boxSizing: 'border-box',
                    }}
                    onClick={() => handleImageClick(product.search_name)}
                >
                    <img
                        src={wineURL + product.image_path}
                        alt={product.name}
                        onLoad={(e) => {
                            const img = e.target as HTMLImageElement;
                            const ratio = img.naturalHeight / img.naturalWidth;
                            setImageRatios(prev => ({...prev, [product.id]: ratio}));
                        }}
                        style={{
                            position: 'absolute',
                            bottom: '50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            ...calculateImageDimensions(imageRatios[product.id] || 1.5, 400),
                            objectFit: 'contain'
                        }}
                    />
                </div>
                <p style={textLight}>{product?.brand?.name}</p>
                <p style={productName}>{product.name}</p>
                <p style={productYear}>{product.year}</p>
                {customer_code && product.price_bottle && (
                    <p style={priceText}>{formatPrice(product.price_bottle)}</p>
                )}
            </div>
        ));
    }

    return <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        // overflow: 'hidden'
    }}>
    <Header />
        <div style={{minHeight: window.innerWidth > 575 ? '650px' : '300px'}}>
            <div style={{display: 'flex', flexDirection: window.innerWidth > 835 ? 'row' : 'column', padding: window.innerWidth > 575 ? 0 : '24px', marginTop: '140px' }}>
                <div style={{flex: 1}}></div>
                <div style={{flex: 1, textAlign: 'left' , marginLeft: window.innerWidth > 575 ? '46px' : '10px'}}>

                        <div className="content-form-field" style={{width: window.innerWidth > 835 ? '70%' : '100%', position: 'relative'}}>
                            <svg
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '14px',
                                    height: '14px',
                                    pointerEvents: 'none',
                                    opacity: 0.6
                                }}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <circle cx="11" cy="11" r="8"/>
                                <path d="m21 21-4.35-4.35"/>
                            </svg>
                            <input
                                type="text"
                                className="input-email"
                                placeholder="Enter Search Term"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                required
                                style={{paddingLeft: '35px'}}
                            />
                        </div>
                </div>

            </div>
            {products !== undefined && products.length > 0 ? (
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        gap: '40px 20px',
                        padding: '30px 20px',
                        margin: '0 auto'
                    }}
                >
                    {(isDesktop ? getDesktopLayout() : getMobileLayout())}
                </div>
            ) : <></>}
        </div>
        <Footer />
    </div>


}

export default Search;
